import React from 'react';
import { DaiperVarient1OuterDiv, DiaperRadioLabel } from './styled';
import { images } from '../../../Constants/ImageUrls';

function DiaperVarient1(props) {
  const { onChangeHandler, option, diaperRadioData, varient } = props;

  return (
    <DaiperVarient1OuterDiv>
      {diaperRadioData.map((data, index) => {
        let selectedItem = data?.id === option;
        return (
          <DiaperRadioLabel
            selected={selectedItem}
            onClick={() => onChangeHandler(data)}
            varient={varient}
            key={data.title + '' + index}
          >
            <div className="maintitle">
              <div className="title">{data.title} </div>
              {selectedItem ? (
                <img src={images.check_circle} alt={'check_mark'} />
              ) : (
                <div className="circle"></div>
              )}
            </div>
            <div className="PriceContainer">
              <div className="priceSection">
                {data.price} <span>{data.strikePrice}</span>
              </div>
              <div className="unitPrice">{data.unitPrice}/diaper</div>
            </div>
          </DiaperRadioLabel>
        );
      })}
    </DaiperVarient1OuterDiv>
  );
}

export default DiaperVarient1;
